import React, { memo } from "react";
import { Link } from "react-router-dom";

export const CitoPlusLink = memo(({ to, children, ...props }) => {
  return (
    <Link
      to={to}
      className={`btn btn-sm ${props.className}`}
      title={props.title}
      onClick={props.onClick}
    >
      {children}
    </Link>
  );
});

// Link sin botones

export const LinkPrimary = memo(({ to, children, ...props }) => {
  const handleClick = (e) => {
    if (props.disabled) {
      e.preventDefault();
      return;
    }
    if (props.onClick) {
      props.onClick(e);
    }
  };

  return (
    <Link
      to={to}
      className={`btn btn-sm btn-citoplus-primary shadow me-1 ${props.disabled ? "disabled" : ""} ${props.className}`}
      title={props.title}
      onClick={handleClick}
      aria-disabled={props.disabled}
      style={props.disabled ? { pointerEvents: "none" } : {}}
    >
      {children}
    </Link>
  );
});

export const LinkSecondary = memo(({ to, children, ...props }) => {
  return (
    <Link
      to={to}
      className={`btn btn-sm btn-citoplus-secondary shadow me-1 ${props.className}`}
      title={props.title}
      onClick={props.onClick}
    >
      {children}
    </Link>
  );
});

export const LinkDanger = memo(({ to, children, ...props }) => {
  return (
    <Link
      to={to}
      className={`btn btn-sm btn-citoplus-danger shadow me-1 ${props.className}`}
      title={props.title}
      onClick={props.onClick}
    >
      {children}
    </Link>
  );
});

// Link con botones

export const CitoPlusLinkIconPrimary = memo(({ to, children, ...props }) => {
  return (
    <Link
      to={to}
      className={`btn btn-sm btn-citoplus-primary shadow content-icon me-1 ${props.className}`}
      title={props.title}
      onClick={props.onClick}
    >
      {children}
    </Link>
  );
});

export const CitoPlusLinkIconDanger = memo(({ to, children, ...props }) => {
  return (
    <Link
      to={to}
      className={`btn btn-sm btn-citoplus-danger shadow content-icon me-1 ${props.className}`}
      title={props.title}
      onClick={props.onClick}
    >
      {children}
    </Link>
  );
});

export const CitoPlusLinkIconSecondary = memo(({ to, children, ...props }) => {
  return (
    <Link
      to={to}
      className={`btn btn-sm btn-citoplus-secondary shadow content-icon me-1 ${props.className}`}
      title={props.title}
      onClick={props.onClick}
    >
      {children}
    </Link>
  );
});

export const CitoPlusLinkIconSuccess = memo(({ to, children, ...props }) => {
  return (
    <Link
      to={to}
      className={`btn btn-sm btn-success shadow content-icon me-1 ${props.className}`}
      title={props.title}
      onClick={props.onClick}
    >
      {children}
    </Link>
  );
});

export const CitoPlusLinkIconWarning = memo(({ to, children, ...props }) => {
  return (
    <Link
      to={to}
      className={`btn btn-sm btn-warning shadow content-icon me-1 ${props.className}`}
      title={props.title}
      onClick={props.onClick}
    >
      {children}
    </Link>
  );
});
